export const socialOutlet = 'social';
